import * as msal from "@azure/msal-browser";
import axios from "axios";

function convertBlobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}
const state = {
    msalConfig: {
        auth: {
            clientId: process.env.VUE_APP_FIREFLY_AZURE_CLIENT_ID,
            authority: process.env.VUE_APP_FIREFLY_AZURE_AUTHORITY_URL + process.env.VUE_APP_FIREFLY_AZURE_TENANT_ID,
            redirectUri: process.env.VUE_APP_FIREFLY_AZURE_REDIRECT_URL,
        },
    },
    msalInstance: null,
    userPhoto: null,
};
const actions = {
    async initializeMsalInstance({ commit, state }) {
        if (!state.msalInstance) {
            state.msalInstance = new msal.PublicClientApplication(state.msalConfig);
            await state.msalInstance.initialize();
        }
    },
    async getProfileAccessToken({ commit, state, dispatch }) {
        if (!state.msalInstance) {
            await dispatch("initializeMsalInstance");
        }
        const account = JSON.parse(sessionStorage.getItem("userAccount"));
        const response = await state.msalInstance.acquireTokenSilent({
            scopes: ["User.Read"],
            account: account,
        });
        if (response && response.accessToken) {
            commit("getTokenSuccessHandler", response.accessToken);
        }
    },
    async getUserProfile({ commit, state, dispatch }) {
        const photoUrl = sessionStorage.getItem('setUserPhoto');
        if (photoUrl) {
            return photoUrl;
        }
        await dispatch("getProfileAccessToken");
        const headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem('profileAccessToken'),
        };
        try {
            const response = await axios.get("https://graph.microsoft.com/v1.0/me/photo/$value", { headers: headers, responseType: "blob" });
            if (response.status === 200) {
                const base64Photo = await convertBlobToBase64(response.data);
                commit("setUserPhoto", base64Photo);
                return base64Photo;
            }
        } catch (error) {
            console.error(error);
        }
    },
}
const mutations = {
    getTokenSuccessHandler(state, token) {
        sessionStorage.setItem("profileAccessToken", token);
    },
    getTokenErrorHandler(error) {
        console.error(error);
    },
    setUserPhoto(state, photoUrl) {
        state.userPhoto = photoUrl;
        sessionStorage.setItem("setUserPhoto", photoUrl);
    },
};
const getters = {};
export const profileStore = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}